module.exports = __webpack_public_path__ + "img/19.323ace1c.jpg";